import React from "react";
import { Link, useParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { addCart, openCart } from "../redux/action";

import { Footer, Navbar } from "../components";
import { useCurrency } from "../context/CurrencyContext";
import { WHATSAPP_PHONE } from "../config";
import useCourses from "../hooks/useCourses";
import { toAnalyticsItem, trackEvent } from "../lib/analytics";

const EMOJI_ICON_MAP = [
  { emoji: "✅", icon: "fa-check-circle" },
  { emoji: "☑️", icon: "fa-check-square-o" },
  { emoji: "✔️", icon: "fa-check" },
  { emoji: "✔", icon: "fa-check" },
  { emoji: "❌", icon: "fa-times-circle" },
  { emoji: "✖️", icon: "fa-times" },
  { emoji: "✖", icon: "fa-times" },
  { emoji: "❎", icon: "fa-times-circle" },
  { emoji: "⚠️", icon: "fa-exclamation-triangle" },
  { emoji: "⚠", icon: "fa-exclamation-triangle" },
  { emoji: "❗", icon: "fa-exclamation-circle" },
  { emoji: "❓", icon: "fa-question-circle" },
  { emoji: "ℹ️", icon: "fa-info-circle" },
  { emoji: "ℹ", icon: "fa-info-circle" },
  { emoji: "⏱️", icon: "fa-clock-o" },
  { emoji: "⏱", icon: "fa-clock-o" },
  { emoji: "⏰", icon: "fa-clock-o" },
  { emoji: "🕒", icon: "fa-clock-o" },
  { emoji: "🕓", icon: "fa-clock-o" },
  { emoji: "🕔", icon: "fa-clock-o" },
  { emoji: "🕕", icon: "fa-clock-o" },
  { emoji: "🕖", icon: "fa-clock-o" },
  { emoji: "🕗", icon: "fa-clock-o" },
  { emoji: "🕘", icon: "fa-clock-o" },
  { emoji: "🕙", icon: "fa-clock-o" },
  { emoji: "🕚", icon: "fa-clock-o" },
  { emoji: "🕛", icon: "fa-clock-o" },
  { emoji: "📄", icon: "fa-file-text-o" },
  { emoji: "📃", icon: "fa-file-text-o" },
  { emoji: "📑", icon: "fa-files-o" },
  { emoji: "📊", icon: "fa-line-chart" },
  { emoji: "📈", icon: "fa-area-chart" },
  { emoji: "📉", icon: "fa-bar-chart" },
  { emoji: "📜", icon: "fa-file-text-o" },
  { emoji: "🧾", icon: "fa-file-text-o" },
  { emoji: "📝", icon: "fa-pencil" },
  { emoji: "✏️", icon: "fa-pencil" },
  { emoji: "✏", icon: "fa-pencil" },
  { emoji: "🧩", icon: "fa-puzzle-piece" },
  { emoji: "📚", icon: "fa-book" },
  { emoji: "📖", icon: "fa-book" },
  { emoji: "📘", icon: "fa-book" },
  { emoji: "📙", icon: "fa-book" },
  { emoji: "📕", icon: "fa-book" },
  { emoji: "📗", icon: "fa-book" },
  { emoji: "🔖", icon: "fa-bookmark" },
  { emoji: "📁", icon: "fa-folder-o" },
  { emoji: "📂", icon: "fa-folder-open-o" },
  { emoji: "🗂️", icon: "fa-folder-open" },
  { emoji: "🗂", icon: "fa-folder-open" },
  { emoji: "🗃️", icon: "fa-archive" },
  { emoji: "🗃", icon: "fa-archive" },
  { emoji: "🗄️", icon: "fa-database" },
  { emoji: "🗄", icon: "fa-database" },
  { emoji: "📦", icon: "fa-cube" },
  { emoji: "🧱", icon: "fa-cubes" },
  { emoji: "📞", icon: "fa-phone" },
  { emoji: "☎️", icon: "fa-phone" },
  { emoji: "☎", icon: "fa-phone" },
  { emoji: "📱", icon: "fa-mobile" },
  { emoji: "✉️", icon: "fa-envelope-o" },
  { emoji: "✉", icon: "fa-envelope-o" },
  { emoji: "📧", icon: "fa-envelope" },
  { emoji: "📨", icon: "fa-envelope" },
  { emoji: "📩", icon: "fa-envelope" },
  { emoji: "📥", icon: "fa-inbox" },
  { emoji: "📤", icon: "fa-share-square-o" },
  { emoji: "📡", icon: "fa-rss" },
  { emoji: "📶", icon: "fa-signal" },
  { emoji: "🌐", icon: "fa-globe" },
  { emoji: "🔗", icon: "fa-link" },
  { emoji: "💻", icon: "fa-laptop" },
  { emoji: "🖥️", icon: "fa-desktop" },
  { emoji: "🖥", icon: "fa-desktop" },
  { emoji: "⌨️", icon: "fa-keyboard-o" },
  { emoji: "⌨", icon: "fa-keyboard-o" },
  { emoji: "🖱️", icon: "fa-hand-o-up" },
  { emoji: "🖱", icon: "fa-hand-o-up" },
  { emoji: "🖨️", icon: "fa-print" },
  { emoji: "🖨", icon: "fa-print" },
  { emoji: "🏭", icon: "fa-industry" },
  { emoji: "📐", icon: "fa-pencil-square-o" },
  { emoji: "📏", icon: "fa-arrows-h" },
  { emoji: "🧮", icon: "fa-calculator" },
  { emoji: "🧠", icon: "fa-lightbulb-o" },
  { emoji: "🔄", icon: "fa-refresh" },
  { emoji: "🔁", icon: "fa-repeat" },
  { emoji: "↔️", icon: "fa-arrows-h" },
  { emoji: "↔", icon: "fa-arrows-h" },
  { emoji: "↕️", icon: "fa-arrows-v" },
  { emoji: "↕", icon: "fa-arrows-v" },
  { emoji: "⬆️", icon: "fa-arrow-up" },
  { emoji: "⬆", icon: "fa-arrow-up" },
  { emoji: "⬇️", icon: "fa-arrow-down" },
  { emoji: "⬇", icon: "fa-arrow-down" },
  { emoji: "⬅️", icon: "fa-arrow-left" },
  { emoji: "⬅", icon: "fa-arrow-left" },
  { emoji: "➡️", icon: "fa-arrow-right" },
  { emoji: "➡", icon: "fa-arrow-right" },
  { emoji: "🛠️", icon: "fa-wrench" },
  { emoji: "🛠", icon: "fa-wrench" },
  { emoji: "📋", icon: "fa-clipboard" },
  { emoji: "⚙️", icon: "fa-cogs" },
  { emoji: "⚙", icon: "fa-cogs" },
  { emoji: "🧪", icon: "fa-flask" },
  { emoji: "🔬", icon: "fa-search-plus" },
  { emoji: "🔭", icon: "fa-search" },
  { emoji: "🧰", icon: "fa-briefcase" },
  { emoji: "⚒️", icon: "fa-gavel" },
  { emoji: "⚒", icon: "fa-gavel" },
  { emoji: "⚖️", icon: "fa-balance-scale" },
  { emoji: "⚖", icon: "fa-balance-scale" },
  { emoji: "🎯", icon: "fa-bullseye" },
  { emoji: "🔧", icon: "fa-wrench" },
  { emoji: "✨", icon: "fa-magic" },
  { emoji: "🔩", icon: "fa-cogs" },
  { emoji: "🎨", icon: "fa-paint-brush" },
  { emoji: "🖌️", icon: "fa-paint-brush" },
  { emoji: "🖌", icon: "fa-paint-brush" },
  { emoji: "⭐", icon: "fa-star" },
  { emoji: "🌟", icon: "fa-star" },
  { emoji: "💡", icon: "fa-lightbulb-o" },
  { emoji: "🎉", icon: "fa-star" },
  { emoji: "🔥", icon: "fa-fire" },
  { emoji: "🏗️", icon: "fa-building-o" },
  { emoji: "🏗", icon: "fa-building-o" },
  { emoji: "🏢", icon: "fa-building" },
  { emoji: "🏛️", icon: "fa-university" },
  { emoji: "🏛", icon: "fa-university" },
  { emoji: "🏠", icon: "fa-home" },
  { emoji: "🌉", icon: "fa-road" },
  { emoji: "🛣️", icon: "fa-road" },
  { emoji: "🛣", icon: "fa-road" },
  { emoji: "🚧", icon: "fa-warning" },
  { emoji: "🚀", icon: "fa-rocket" },
  { emoji: "✈️", icon: "fa-plane" },
  { emoji: "✈", icon: "fa-plane" },
  { emoji: "🚢", icon: "fa-ship" },
  { emoji: "🚚", icon: "fa-truck" },
  { emoji: "🚜", icon: "fa-truck" },
  { emoji: "⛽", icon: "fa-car" },
  { emoji: "🚦", icon: "fa-exchange" },
  { emoji: "🎥", icon: "fa-video-camera" },
  { emoji: "🎬", icon: "fa-film" },
  { emoji: "🎧", icon: "fa-headphones" },
  { emoji: "🔊", icon: "fa-volume-up" },
  { emoji: "🎙️", icon: "fa-microphone" },
  { emoji: "🎙", icon: "fa-microphone" },
  { emoji: "📹", icon: "fa-video-camera" },
  { emoji: "📸", icon: "fa-camera" },
  { emoji: "🖼️", icon: "fa-picture-o" },
  { emoji: "🖼", icon: "fa-picture-o" },
  { emoji: "🛒", icon: "fa-shopping-cart" },
  { emoji: "🛍️", icon: "fa-shopping-bag" },
  { emoji: "🛍", icon: "fa-shopping-bag" },
  { emoji: "💳", icon: "fa-credit-card" },
  { emoji: "💰", icon: "fa-money" },
  { emoji: "\u{1F381}", icon: "fa-gift" },
  { emoji: "\u{1F4CC}", icon: "fa-thumb-tack" },
  { emoji: "\u{1F512}", icon: "fa-lock" },
  { emoji: "\u{1F3F9}", icon: "fa-location-arrow" },
  { emoji: "\u{1FAA2}", icon: "fa-link" },
  { emoji: "\u2795", icon: "fa-plus" },
  { emoji: "\u{1F916}", icon: "fa-android" },
  { emoji: "\u{1F4BE}", icon: "fa-save" },
  { emoji: "\u{1F50C}", icon: "fa-plug" },
  { emoji: "\u23F3", icon: "fa-hourglass-half" },
  { emoji: "\u{1F4A7}", icon: "fa-tint" },
  { emoji: "\u{1FAA3}", icon: "fa-shopping-basket" },
  { emoji: "\u{1F4A6}", icon: "fa-tint" },
  { emoji: "\u{1F44B}", icon: "fa-hand-paper-o" },
  { emoji: "\u{1F3D5}\uFE0F", icon: "fa-tree" },
  { emoji: "\u{1F3D5}", icon: "fa-tree" },
  { emoji: "\u{1FAB5}", icon: "fa-tree" },
  { emoji: "\u{1F9F4}", icon: "fa-flask" },
  { emoji: "\u{1F53A}", icon: "fa-caret-up" },
  { emoji: "\u{1F6AA}", icon: "fa-sign-in" },
  { emoji: "\u{1F6A8}", icon: "fa-bell" },
  { emoji: "\u{1F449}", icon: "fa-hand-o-right" },
  { emoji: "🏷️", icon: "fa-tag" },
  { emoji: "🏷", icon: "fa-tag" },
  { emoji: "🥇", icon: "fa-trophy" },
  { emoji: "🔰", icon: "fa-shield" },
  { emoji: "👇", icon: "fa-hand-o-down" },
  { emoji: "🔴", icon: "fa-circle" },
  { emoji: "▶️", icon: "fa-play" },
  { emoji: "▶", icon: "fa-play" },
  { emoji: "🆒", icon: "fa-thumbs-up" },
  { emoji: "🎓", icon: "fa-graduation-cap" },
  { emoji: "👤", icon: "fa-user" },
  { emoji: "👥", icon: "fa-users" },
  { emoji: "‍♂️", icon: "fa-mars" },
  { emoji: "‍♂", icon: "fa-mars" },
  { emoji: "♂️", icon: "fa-mars" },
  { emoji: "♂", icon: "fa-mars" },
  { emoji: "👷", icon: "fa-user" },
  { emoji: "👷‍♂️", icon: "fa-user" },
  { emoji: "👨‍🏫", icon: "fa-user" },
  { emoji: "👩‍🏫", icon: "fa-user" },
  { emoji: "🤝", icon: "fa-users" },
];

const emojiIconHtml = EMOJI_ICON_MAP.reduce((acc, item) => {
  acc[item.emoji] = `<i class="fa ${item.icon} syllabus-icon" aria-hidden="true"></i>`;
  return acc;
}, {});

const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const replaceEmojisWithIcons = (value) => {
  let output = String(value || "");
  Object.entries(emojiIconHtml).forEach(([emoji, iconHtml]) => {
    output = output.split(emoji).join(` ${iconHtml} `);
  });
  return output;
};

const sanitizeHtml = (rawHtml) => {
  if (typeof window === "undefined") {
    return rawHtml;
  }

  const parser = new window.DOMParser();
  const doc = parser.parseFromString(rawHtml, "text/html");
  const blockedTags = new Set(["script", "style", "iframe", "object", "embed"]);

  doc.querySelectorAll("*").forEach((node) => {
    const tag = node.tagName.toLowerCase();

    if (blockedTags.has(tag)) {
      node.remove();
      return;
    }

    [...node.attributes].forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = attr.value || "";

      if (name.startsWith("on")) {
        node.removeAttribute(attr.name);
        return;
      }

      if ((name === "href" || name === "src") && /^\s*javascript:/i.test(value)) {
        node.removeAttribute(attr.name);
      }
    });
  });

  return doc.body.innerHTML;
};

const decodeHtmlEntities = (value) => {
  if (typeof window === "undefined") {
    return value;
  }

  const helper = window.document.createElement("textarea");
  helper.innerHTML = value;
  return helper.value;
};

const decodeHtmlEntitiesDeep = (value, maxPasses = 4) => {
  let output = String(value || "");

  for (let i = 0; i < maxPasses; i += 1) {
    const decoded = decodeHtmlEntities(output);
    if (decoded === output) {
      break;
    }
    output = decoded;
  }

  return output;
};

const Product = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const { formatPrice, currency } = useCurrency();
  const courses = useCourses();
  const scrollRef = useRef(null);
  const dragState = useRef({ isDown: false, startX: 0, scrollLeft: 0 });
  const pauseRef = useRef(false);
  const rafRef = useRef(null);
  const lastViewItemId = useRef("");

  const product = courses.find(
    (item) => item.slug === slug || String(item.id) === slug
  );
  const similarProducts = product
    ? courses.filter((item) => item.id !== product.id)
    : [];
  const hasDiscount =
    product && product.originalPrice && product.originalPrice > product.price;
  const pageUrl = typeof window !== "undefined" ? window.location.href : "";
  const whatsappMessage = product
    ? `Hola, quiero informacion sobre: ${product.title}.
URL: ${pageUrl}`
    : `Hola, quiero informacion.
URL: ${pageUrl}`;
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
    whatsappMessage
  )}`;

  const addProduct = (item) => {
    trackEvent("add_to_cart", {
      currency,
      value: Number(item.price || 0),
      items: [toAnalyticsItem(item, 1)],
    });
    dispatch(addCart(item));
    dispatch(openCart());
  };

  const handleMouseDown = (event) => {
    const container = scrollRef.current;
    if (!container) return;
    pauseRef.current = true;
    dragState.current.isDown = true;
    dragState.current.startX = event.pageX - container.offsetLeft;
    dragState.current.scrollLeft = container.scrollLeft;
    container.classList.add("is-dragging");
  };

  const handleMouseLeave = () => {
    const container = scrollRef.current;
    if (!container) return;
    dragState.current.isDown = false;
    pauseRef.current = false;
    container.classList.remove("is-dragging");
  };

  const handleMouseUp = () => {
    const container = scrollRef.current;
    if (!container) return;
    dragState.current.isDown = false;
    pauseRef.current = false;
    container.classList.remove("is-dragging");
  };

  const handleMouseMove = (event) => {
    const container = scrollRef.current;
    if (!container || !dragState.current.isDown) return;
    event.preventDefault();
    const x = event.pageX - container.offsetLeft;
    const walk = x - dragState.current.startX;
    container.scrollLeft = dragState.current.scrollLeft - walk;
  };

  const handleArrow = (direction) => {
    const container = scrollRef.current;
    if (!container) return;
    pauseRef.current = true;
    const amount = 320 * direction;
    container.scrollBy({ left: amount, behavior: "smooth" });
    window.setTimeout(() => {
      pauseRef.current = false;
    }, 700);
  };

  const handleTouchStart = (event) => {
    const container = scrollRef.current;
    if (!container) return;
    pauseRef.current = true;
    dragState.current.isDown = true;
    dragState.current.startX = event.touches[0].pageX - container.offsetLeft;
    dragState.current.scrollLeft = container.scrollLeft;
  };

  const handleTouchMove = (event) => {
    const container = scrollRef.current;
    if (!container || !dragState.current.isDown) return;
    const x = event.touches[0].pageX - container.offsetLeft;
    const walk = x - dragState.current.startX;
    container.scrollLeft = dragState.current.scrollLeft - walk;
  };

  const handleTouchEnd = () => {
    dragState.current.isDown = false;
    pauseRef.current = false;
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const step = () => {
      if (!container) return;
      if (!pauseRef.current) {
        container.scrollLeft += 0.4;
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
      rafRef.current = requestAnimationFrame(step);
    };

    rafRef.current = requestAnimationFrame(step);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [similarProducts.length]);

  useEffect(() => {
    if (!product) {
      document.title = "Programa no encontrado | A1 Pro";
      return;
    }

    document.title = `${product.title} | A1 Pro`;

    const marker = String(product.id);
    if (lastViewItemId.current === marker) {
      return;
    }

    trackEvent("view_item", {
      currency,
      value: Number(product.price || 0),
      items: [toAnalyticsItem(product, 1)],
    });

    lastViewItemId.current = marker;
  }, [product, currency]);

  const renderLongDescription = (text) => {
    if (!text) return null;

    const normalizedText = decodeHtmlEntitiesDeep(text).trim();
    const hasHtml = /<\/?[a-z][\s\S]*>/i.test(normalizedText);

    if (hasHtml) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(replaceEmojisWithIcons(normalizedText)),
          }}
        />
      );
    }

    const plainText = normalizedText.replace(/<br\s*\/?>/gi, "\n");
    const lines = plainText
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
    const elements = [];
    let listItems = [];
    let key = 0;

    const flushList = () => {
      if (listItems.length > 0) {
        elements.push(
          <ul className="mb-3" key={`ul-${key++}`}>
            {listItems}
          </ul>
        );
        listItems = [];
      }
    };

    lines.forEach((line) => {
      if (line.startsWith("- ")) {
        listItems.push(
          <li
            key={`li-${key++}`}
            dangerouslySetInnerHTML={{
              __html: replaceEmojisWithIcons(escapeHtml(line.replace("- ", ""))),
            }}
          />
        );
      } else {
        flushList();
        elements.push(
          <p
            className="mb-2"
            key={`p-${key++}`}
            dangerouslySetInnerHTML={{
              __html: replaceEmojisWithIcons(escapeHtml(line)),
            }}
          />
        );
      }
    });

    flushList();
    return elements;
  };

  if (!product) {
    return (
      <>
        <Navbar />
        <div className="container my-5 py-5 text-center">
          <h2 className="mb-3">Programa no encontrado</h2>
          <Link to="/product" className="btn btn-dark">
            Ver cursos
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container">
        <div className="row">
          <div className="container my-5 py-2">
            <div className="row">
              <div className="col-md-6 col-sm-12 py-3" data-aos="fade-right">
                <img
                  className="img-fluid"
                  src={product.image}
                  alt={product.title}
                  width="400px"
                  height="400px"
                />
                <div className="mt-4" data-aos="fade-up" data-aos-delay="150">
                  <h5 className="mb-3">Descripcion detallada</h5>
                  <div className="product-long-description">
                    {renderLongDescription(product.longDescription)}
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-md-6 py-5" data-aos="fade-left">
                <h4 className="text-uppercase text-muted">{product.category}</h4>
                <h1 className="display-5">{product.title}</h1>
                {product.rating ? (
                  <p className="lead">
                    {product.rating.rate} <i className="fa fa-star"></i>
                  </p>
                ) : null}
                <div className="my-4">
                  <div className="price-row price-row-left">
                    <span className="price-current price-current-lg">
                      {formatPrice(product.price)}
                    </span>
                    {hasDiscount ? (
                      <span className="price-original price-original-lg">
                        {formatPrice(product.originalPrice)}
                      </span>
                    ) : null}
                  </div>
                </div>
                <p className="lead">{product.shortDescription}</p>
                <div
                  className="mt-3 product-actions"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <button
                    className="btn course-action-btn course-action-primary"
                    onClick={() => addProduct(product)}
                    aria-label="Agregar al carrito"
                    title="Agregar al carrito"
                  >
                    <i className="fa fa-shopping-cart me-2" aria-hidden="true"></i>
                    Comprar
                  </button>
                  <Link
                    to="/cart"
                    className="btn course-action-btn course-action-secondary product-cart-btn"
                  >
                    <i className="fa fa-shopping-bag me-2" aria-hidden="true"></i>
                    Ir al carrito
                  </Link>
                  <a
                    href={whatsappUrl}
                    className="btn btn-whatsapp course-action-btn course-action-whatsapp"
                    onClick={() =>
                      trackEvent("whatsapp_click", {
                        source: "product_detail",
                        item_id: product.slug,
                      })
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    Por WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row my-5 py-5">
          <div className="d-none d-md-block">
            <h2 className="" data-aos="fade-up">
              Recomendados para ti
            </h2>
            <div className="recommendations-wrap">
              <button
                className="rec-arrow rec-arrow-left"
                type="button"
                aria-label="Anterior"
                onClick={() => handleArrow(-1)}
              >
                &lsaquo;
              </button>
              <div
                className="recommendations"
                ref={scrollRef}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                {[...similarProducts, ...similarProducts].map((item, idx) => {
                  return (
                    <div
                      key={`${item.id}-${idx}`}
                      className="card recommendation-card text-center"
                    >
                      <img
                        className="card-img-top p-3 course-card-img"
                        src={item.image}
                        alt={item.title}
                      />
                      <div className="card-body">
                        <h5 className="card-title">{item.title}</h5>
                      </div>
                      <div className="card-body course-actions">
                        <Link
                          to={"/product/" + item.slug}
                          className="btn course-action-btn course-action-secondary"
                          aria-label="Ver temario"
                          title="Ver temario"
                        >
                          <i className="fa fa-eye me-2" aria-hidden="true"></i>
                          Ver temario
                        </Link>
                        <button
                          className="btn course-action-btn course-action-primary"
                          onClick={() => addProduct(item)}
                          aria-label="Agregar al carrito"
                          title="Agregar al carrito"
                        >
                          <i className="fa fa-shopping-cart me-2" aria-hidden="true"></i>
                          Comprar
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
              <button
                className="rec-arrow rec-arrow-right"
                type="button"
                aria-label="Siguiente"
                onClick={() => handleArrow(1)}
              >
                &rsaquo;
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Product;
